import { useMemo } from 'react';
import { getQueryParams } from 'src/helpers/history';
import qs from 'qs';

export function useAdminHref(href: string): string {
  const qp = getQueryParams();

  return useMemo(() => {
    return `${href}?${qs.stringify(qp)}`;
  }, [href, qp]);
}
